export default function isEmptyHelper(value) {
  if (value == null) {
    return true
  }

  if (typeof value === 'string' || Array.isArray(value) || value instanceof Set || value instanceof Map) {
    return value.size === 0 || value.length === 0
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0
  }

  return false
}
